<template>
  <div>
    <el-menu :default-active="selectedTab" @select="setSelectedTab" @dblclick.native="handleDoubleClick" background-color="#2E314A" :collapse="menuIsCollapsed" :router="true" :collapse-transition="false">
      <img class="logo" src="~@/assets/flux-logo.svg" v-if="!menuIsCollapsed">
      <img class="logo collapse" src="~@/assets/logo-collapse.svg" v-if="menuIsCollapsed">

      <div class="user" v-if="!menuIsCollapsed">
        <font-awesome-icon icon="user" class="menu-icon"/>
        <el-dropdown @command="userActions" size="mini" trigger="click">
          <span class="el-dropdown-link">
            {{user.attributes.firstName}} {{user.attributes.lastName}}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="logout">Logout</el-dropdown-item>
            <el-dropdown-item command="changePassword">Change password</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <div class="user" v-if="menuIsCollapsed">
        <el-dropdown @command="userActions" size="mini" trigger="click">
          <span class="el-dropdown-link">
            <font-awesome-icon icon="user" class="menu-icon"/>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="logout">Logout</el-dropdown-item>
            <el-dropdown-item command="changePassword">Change password</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <el-menu-item index="1" route="/time-log">
        <font-awesome-icon icon="clock" class="menu-icon" />
        <span slot="title">Time Log</span>
      </el-menu-item>

      <el-menu-item index="2" route="/calendar">
        <font-awesome-icon icon="calendar-alt" class="menu-icon" />
        <span slot="title">Calendar</span>
      </el-menu-item>

      <el-menu-item index="3" class="summary" route="/summary">
        <font-awesome-icon icon="chart-pie" class="menu-icon" />
        <span slot="title">Summary</span>
      </el-menu-item>
<!--
      <el-menu-item index="4" class="settings" route="/settings" v-if="userRole && (userRole.attributes.name === 'admin' || userRole.attributes.name === 'manager')">
        <font-awesome-icon icon="cog" class="menu-icon" />
        <span slot="title">Settings</span>
      </el-menu-item>
-->
      <div index="5" class="admin" :class="{ 'is-active': adminMode }" :route="$route.path" v-if="userRole && (userRole.attributes.name === 'admin' || userRole.attributes.name === 'manager')">
        <el-tooltip placement="right" content='Admin Mode'>
          <div class="menu-icon" @click="toggleIsAdmin"></div>
        </el-tooltip>
        <span slot="title" class="switch">
          <el-switch v-if="!menuIsCollapsed" v-model="adminMode"></el-switch>
        </span>
      </div>
      <current-task class="current-task" :collapsed="menuIsCollapsed"></current-task>
      <div class="collapsible" :class="{ 'expand': menuIsCollapsed, 'collapse': !menuIsCollapsed}" @click="menuIsCollapsed = !menuIsCollapsed">
        <div>
          <div>
            <font-awesome-icon icon="chevron-right" v-if="menuIsCollapsed"></font-awesome-icon>
            <font-awesome-icon icon="chevron-left" v-if="!menuIsCollapsed"></font-awesome-icon>
          </div>
        </div>
      </div>
    </el-menu>
    <el-dialog title="Change Password" :visible.sync="changePasswordDialogIsVisible" width="500px" class="change-password-dialog" :close-on-click-modal="false">
      <el-form ref="form" label-width="170px">
        <el-form-item label="New Password">
          <el-input v-model="newPassword" type="password" ref="newPassword"></el-input>
        </el-form-item>
        <el-form-item label="Confirm New Password">
          <el-input v-model="confirmPassword" type="password" :class="{ invalid: newPassword != confirmPassword }"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="changePasswordDialogIsVisible = false">Cancel</el-button>
          <el-button @click="changePassword" type="primary" :disabled="!passwordSaveIsEnabled">Save</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>

import CurrentTask from '@/components/CurrentTask'
import { getDateRangeFromRangeIndex } from '@/utils/timeRange'
import { lazyLoadAll } from '@/utils/store'
import { EventHub } from '@/components/EventHub'

export default {

  components: {
    CurrentTask
  },
  data () {
    return {
      menuIsCollapsed: true,
      windowWidth: 0,
      newPassword: null,
      confirmPassword: null,
      changePasswordDialogIsVisible: false
    }
  },
  computed: {
    selectedTab () {
      return this.$store.state.selectedTab.selectedTab
    },
    user () {
      return this.$store.state.authentication.user
    },
    adminMode: {
      get () {
        return this.$store.getters.adminMode
      },
      set (state) {
        this.$store.commit('updateIsAdmin', state)
      }
    },
    userRole () {
      let role = this.$store.getters['roles/byId']({ id: this.user.relationships.role.data.id })

      if (role && role.attributes.name !== 'admin' && role.attributes.name !== 'manager') {
        this.$store.commit('updateIsAdmin', false)
      }
      return role
    },
    passwordSaveIsEnabled () {
      return this.newPassword && this.confirmPassword && this.newPassword === this.confirmPassword
    }
  },
  watch: {
    windowWidth (newWidth, oldWidth) {
      if (newWidth < 1500) {
        this.menuIsCollapsed = true
      } else {
        this.menuIsCollapsed = false
      }
    }
  },
  methods: {
    keypress (e) {
      e.keyCode === 13 && this.changePasswordDialogIsVisible && this.passwordSaveIsEnabled && this.changePassword()
    },
    toggleIsAdmin () {
      let current = this.$store.getters.adminMode
      this.$store.commit('updateIsAdmin', !current)
    },
    setSelectedTab (tab) {
      if ((tab !== this.$store.getters.selectedTab) && ['1', '2', '3'].includes(tab)) {
        lazyLoadAll()
      }
      this.$store.commit('updateSelectedTab', tab)
    },
    handleDoubleClick () {
      this.$store.commit('updateCurrentDateRange', getDateRangeFromRangeIndex('week', 0))
      EventHub.$emit('clear-search')
      this.$store.commit('updateIsAdmin', false)
    },
    userActions (command) {
      switch (command) {
        case 'logout':
          this.$store.dispatch('logout').then(() => {
            this.$router.push('/login')
          })
          break
        case 'changePassword':
          this.newPassword = null
          this.confirmPassword = null
          this.changePasswordDialogIsVisible = true
          this.$nextTick(() => this.$refs['newPassword'].focus())
          break
      }
    },
    changePassword () {
      let user = this.user
      let sha1 = require('sha1')
      let authKey = sha1(this.newPassword)

      user.attributes.authKey = authKey
      this.$store.dispatch('users/update', user)
      this.changePasswordDialogIsVisible = false
    }
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
      })
    })
  },
  created () {
    document.addEventListener('keypress', this.keypress)
  },
  beforeDestroy () {
    document.removeEventListener('keypress', this.keypress)
  }
}
</script>

<style lang='scss' >
@import '../styles/common.scss';

.el-menu{
  text-decoration: none !important;
  background-color: #2E314A !important;
  color: #fff;
  min-width: 200px;
  min-height: 400px;
  height: 100%;
    
  &.el-menu--collapse {
    min-width: 66px;
  }
  .logo{
    margin: 13px 0px 20px 18px;
    width: 101px;
    height: 45px;

    &.collapse {
      width: 27px;
      height:45px;
    }
  }
  .user {
    padding-left: 20px;

    svg {
      vertical-align: middle;
      color: #FFF;
    }
    .el-dropdown-link {
      cursor: pointer;
      color: #FFF;

      .el-icon-arrow-down {
        font-size: 12px;
      }
    }
  }
  .menu-icon{
    font-size:20px;
    min-width:20px;
    padding:10px;
    text-align:left;
    margin-left:-10px;
  }
  .el-menu-item {
    color: #fff;

    &.is-active {
      color: #e8a600 !important;
    }
    &.summary {

      svg {
        transform: rotate(90deg) scaleX(-1);
      }
    }
    
  }
  .admin {
    
    padding-left:20px;
    .el-switch{
      margin-bottom:15px !important;
    }

    .menu-icon {
      background: url(~@/assets/flux-capacitor.svg) no-repeat center center;
      
      padding:1px !important;
      height: 20px !important;
      width: 20px !important;
      margin:0px !important;
      margin-right:10px !important;
      margin-top:10px !important;
      display: inline-block;
      margin-bottom: -2px;
    }
    &.is-active {
      color: $warning-color;
      .menu-icon {
        background-image: url(~@/assets/flux-capacitor-active.svg);
      }
    }
  }
  .collapsible {
    position: absolute;
    right: -5px;
    top: 0px;
    width: 10px;
    height: 100%;
    cursor: col-resize;
    
    > div {
      width: 18px;
      height: 50px;
      position: absolute;
      top: 50%;
      left: -4px;
      overflow: hidden;
      cursor: pointer;

      div {
        position: absolute;
        width: 40px;
        height: 50px;
        border-radius: 50%;
        display: flex;
        align-items: center;
      }
    }
    svg {
      font-size: 12px;
      transform: scale(1,1.3);
    }
    &.expand {

      > div div {
        right: 0px;
        background-color: #2e314a;
        justify-content: flex-end;
      }
      svg {
        margin-right: 4px;
        color: rgba(255,255,255,0.8);
      }
    }
    &.collapse {

      > div div {
        background-color: $light-gray;
      }
      svg {
        margin-left: 4px;
        color: #2e314a;
      }
    }
  }
}
.change-password-dialog {

  .el-form-item:last-child {
    margin-bottom: 0px;
    text-align: right;
  }
  .invalid input:focus {
    border-color: $light-red;
  }
}
</style>

